module.exports = __webpack_public_path__ + "static/media/invite3.8e8ba2bd.svg";